// extracted by mini-css-extract-plugin
export default {"card":"Card_card__CXscc","card_header":"Card_card_header__FReSU","title":"Card_title__mH1Iq"};